export const LOCALES = ['es', 'en', 'pt-BR'];
export const PREFERENCE_KEY = 'bison-locale';
export const isLocale = (value) => LOCALES.includes(value);
export function localeForLanguages(languages = []) {
  for (const language of languages) {
    const base = String(language).toLowerCase().split('-')[0];
    if (base === 'pt') return 'pt-BR';
    if (base === 'es' || base === 'en') return base;
  }
  return 'es';
}
export function readPreference(storage, cookie = '') {
  const cookieValue = cookie
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith(`${PREFERENCE_KEY}=`))
    ?.slice(PREFERENCE_KEY.length + 1);
  if (isLocale(cookieValue)) return cookieValue;
  try {
    const value = storage?.getItem(PREFERENCE_KEY);
    return isLocale(value) ? value : null;
  } catch {
    return null;
  }
}
export function preferenceCookie(locale, hostname, secure) {
  const sharedDomain =
    hostname === 'bisonagents.com' || hostname.endsWith('.bisonagents.com');
  return `${PREFERENCE_KEY}=${locale}; Path=/; Max-Age=31536000; SameSite=Lax${secure ? '; Secure' : ''}${sharedDomain ? '; Domain=.bisonagents.com' : ''}`;
}
